import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/home-view.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "HomeView", component: HomeView },
  {
    path: "/product",
    name: "ProductView",
    component: () => import("@/views/product-view.vue"),
  },
  {
    path: "/download",
    name: "DownloadView",
    component: () => import("@/views/download-view.vue"),
  },
  {
    path: "/about",
    name: "AboutView",
    component: () => import("@/views/about-view.vue"),
  },
  {
    path: "/manual",
    name: "ManualView",
    component: () => import("@/views/manual-view.vue"),
  },
  {
    path: "/manualde",
    name: "ManualdeView",
    component: () => import("@/views/manualde-view.vue"),
  },
  {
    path: "/help",
    name: "HelpView",
    component: () => import("@/views/help-view.vue"),
  },
  {
    path: "/helpdo",
    name: "HelpdoView",
    component: () => import("@/views/helpdo-view.vue"),
  },
];

const router = new VueRouter({ mode: "history", routes });

export default router;
